import { render, staticRenderFns } from "./OrganizationsActivityReport.vue?vue&type=template&id=6b63c40a&"
import script from "./OrganizationsActivityReport.vue?vue&type=script&lang=js&"
export * from "./OrganizationsActivityReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports